import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

let CreatePopupOptions = {
  classes: {
    popupClass: "abacusPopup",
    popupContentClass: "abacusPopupContent"
  }
};

class CreatePopup extends Class {
  constructor(options) {
    super();
    this.setOptions(CreatePopupOptions, options);
    this.bodyEl = $(document.body);
    this.create();
  }

  create() {
    if ($(`.${this.options.classes.popupClass}`).length === 0) {
      this.bodyEl.append(
        `<div class="${
          this.options.classes.popupClass
        }" tabindex="0" aria-labelledby="popupLabel" role="dialog"><div class="sleeve"><div class="${
          this.options.classes.popupContentClass
        }"></div></div></div>`
      );
    }
  }
}

export { CreatePopup };



// WEBPACK FOOTER //
// ./Javascript/core/classes/popups/popup.create.class.js